import React from 'react';

import styles from './NeonClock.module.css';

const segmentConfig = {
  0: [true, true, true, true, true, true, false],
  1: [false, false, false, true, false, true, false],
  2: [true, true, false, true, true, false, true],
  3: [true, true, false, true, false, true, true],
  4: [false, false, true, true, false, true, true],
  5: [true, true, true, false, false, true, true],
  6: [true, true, true, false, true, true, true],
  7: [true, false, false, true, false, true, false],
  8: [true, true, true, true, true, true, true],
  9: [true, true, true, true, false, true, true],
};

const Digit = ({ value }) => {
  const segments = segmentConfig[value] || [false, false, false, false, false, false, false];

  return (
    <div className={styles.digit} data-digit={value}>
      <span className={`${styles.end} ${styles.top}`} style={{ '--act': segments[0] ? 1 : 0 }}></span>
      <span className={`${styles.end} ${styles.bottom}`} style={{ '--act': segments[1] ? 1 : 0 }}></span>
      <span className={`${styles.side} ${styles.left}`} style={{ '--act': segments[2] ? 1 : 0 }}></span>
      <span className={`${styles.side} ${styles.right}`} style={{ '--act': segments[3] ? 1 : 0 }}></span>
      <span className={`${styles.side} ${styles.left} ${styles.bottom}`} style={{ '--act': segments[4] ? 1 : 0 }}></span>
      <span className={`${styles.side} ${styles.right} ${styles.bottom}`} style={{ '--act': segments[5] ? 1 : 0 }}></span>
      <span className={styles.middle} style={{ '--act': segments[6] ? 1 : 0 }}></span>
      <div className={`${styles.shadow} ${styles.shadow1}`}></div>
      <div className={`${styles.shadow} ${styles.shadow2}`}></div>
    </div>
  );
};

const Colon = () => (
  <div className={`${styles.colonGroup}`}>
    <div className={styles.colon}>
      <span></span>
    </div>
  </div>
);

const NeonClock = ({ value }) => {
  return (
    <div className={`${styles.wrapper}`}>
      <main className={styles.main}>
        <div className={styles.digits}>
          <div className={styles.group}>
            {value && value.toString().split('').map((digit, index) => 
              <Digit key={index} value={digit} />
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default NeonClock;
